// @ts-ignore
const request = require.context('@template/sso/_component/modal/', false, /^(\.\/modal).*(\.vue)$/);
let module: any = {};

request.keys().forEach((path: string) => {
  const name = path
    .replace('./', '')
    .replace('.vue', '');
  
  module[name] = request(path).default;
});

export default module;